'use client';

import { globalizationService } from '../../../services/globalizationService';
import clsx from 'clsx';
import Parser from 'html-react-parser';
import Link from 'next/link';
import { EpButton, EpCard } from '../../../components';
import {
  ROUTE_INCIDENT_NOTIFICATION,
  ROUTE_INCIDENT_NOTIFICATION_SEARCH,
} from '../../../constants/urlConstants';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { userService } from '../../../services/userService';
import { useHospitalStore } from '../../../stores/useHospitalStore';
import { useTranslationStore } from '../../../stores/useTranslationStore';
import styles from '../EpStarter.module.scss';
import { IStarterInitialContentProps } from './EpStarterInitialContent';
import { CountryCode, parsePhoneNumber } from 'libphonenumber-js';
import { useTranslation } from 'react-i18next';
import { getDefaultAccess } from '../../../utils/defaultAccess';

export const StarterHomePS = ({
  logged,
  tag = '',
}: IStarterInitialContentProps) => {
  const {
    i18n: { language },
  } = useTranslation();
  const { translations } = useTranslationStore((state) => state);
  const { hospitalInfo } = useHospitalStore((state) => state);
  const { getHospitalInfo } = userService;
  const { data: contactInfo, isLoading } = getHospitalInfo(
    hospitalInfo?.HospitalId || '',
  );
  const { translations: locales } =
    globalizationService.getTranslationsByTag(tag);

  const hospitalInfoName = getDefaultAccess()?.hospital?.name;

  return (
    <>
      <aside className={styles['section__aside']}>
        <h1 className={styles['typograph__title']}>
          {t(translations['global'], 'Notification of')}{' '}
          <strong className={styles['typograph__strong']}>
            {t(translations['global'], 'Patient Safety')}
          </strong>
        </h1>

        {!isLoading && contactInfo && contactInfo.enabled && (
          <p className={styles['typograph__help']}>
            {contactInfo?.messageContact && contactInfo?.messageContact}
            <p className={styles['typograph__blue']}>
              {/* {contactInfo?.phoneNumber &&
                parsePhoneNumber(
                  contactInfo?.phoneNumber.replace(/\D+/g, ''),
                  language === 'en'
                    ? 'US'
                    : language?.length > 2 ? language.split('-')[1] as CountryCode : language?.toUpperCase() as CountryCode,
                ).formatNational()} */}
              {contactInfo?.phoneNumber}{' '}
              {contactInfo?.email && contactInfo?.email}
            </p>
          </p>
        )}
      </aside>

      <div className={styles['card']}>
        <EpCard
          cardId="ep-card-default"
          cardElevation="one"
          cardSpace="xl"
          cardHeaderIconName="solid-cube"
          cardBodyContentWidthType="contained"
          cardHeight="self"
          cardWidth={520}
        >
          <div slot="card-body-content">
            <div className={styles['card__content']}>
              <p className={styles['typograph__card--txt']}>
                {Parser(
                  t(
                    locales,
                    'Create a new notification related to an incident or adverse event that occurred at {0}',
                  ).replace('{0}', hospitalInfoName),
                )}
              </p>

              <i className={styles['typograph__card--desc']}>
                {t(
                  locales,
                  'This notification will be forwarded to the Quality Office and/or Patient Safety Center so that appropriate action can be taken.',
                )}
              </i>
            </div>

            <div
              className={clsx(
                styles['card__footer'],
                logged && styles['card__footer--btn-center'],
              )}
            >
              {!logged && (
                <Link href={ROUTE_INCIDENT_NOTIFICATION_SEARCH}>
                  <EpButton
                    buttonId="search-notification"
                    buttonType="link-secondary"
                    buttonSize="md"
                    buttonText={t(
                      translations['global'],
                      'Search Notification',
                    )}
                  />
                </Link>
              )}

              <Link href={ROUTE_INCIDENT_NOTIFICATION}>
                <EpButton
                  buttonId="create-notification"
                  buttonType="primary"
                  buttonSize="md"
                  buttonText={t(translations['global'], 'Create notification')}
                  buttonLeftIconName="SolidCheck"
                />
              </Link>
            </div>
          </div>
        </EpCard>
      </div>
    </>
  );
};
